import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function OverstockDetail() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
